import c, { useLayoutEffect as k, useEffect as m } from "react";
const v = typeof window < "u" ? k : m;
function i(n) {
  const e = c.useRef({
    stableFn: (...s) => e.current.callback?.(...s),
    callback: n
  });
  return v(() => {
    e.current.callback = n;
  }), e.current.stableFn;
}
const p = {
  when: !0
};
function h(n, e, s) {
  const r = { ...p, ...s }, u = i(n);
  c.useEffect(() => {
    if (r.when) {
      const o = (l) => {
        e.current && !e.current.contains(l.target) && u();
      };
      return requestIdleCallback(() => {
        document.addEventListener("click", o, !1);
      }), () => {
        document.removeEventListener("click", o, !1);
      };
    }
    return () => {
    };
  }, [u, e, r.when]);
}
const f = {
  when: !0
};
function w(n, e, s = f) {
  const r = i(n), u = c.useRef(), o = { ...f, ...s }, { when: l } = o, t = c.useCallback(() => {
    clearInterval(u.current);
  }, []), a = c.useCallback(() => {
    t(), u.current = setInterval(() => r(), e);
  }, [e, r, t]);
  c.useEffect(() => (l && a(), () => {
    t();
  }), [l, a, t]);
  const d = c.useCallback(() => {
    t(), a();
  }, [t, a]);
  return {
    startInterval: a,
    stopInterval: t,
    restartInterval: d
  };
}
function I({
  callback: n,
  target: e
}) {
  const s = i(n);
  return v(() => {
    const r = e && "current" in e ? e.current : e;
    if (!r)
      return () => {
      };
    function u(l, t) {
      s(l, t);
    }
    const o = new ResizeObserver(u);
    return o.observe(r), () => {
      o.disconnect();
    };
  }, [e, s]), null;
}
const b = {
  when: !0
};
function C(n, e, s = b) {
  const r = i(n), u = c.useRef(), o = { ...b, ...s }, { when: l } = o, t = c.useCallback(() => {
    clearTimeout(u.current);
  }, []), a = c.useCallback(() => {
    t(), u.current = setTimeout(() => r(), e);
  }, [e, r, t]);
  return c.useEffect(() => (l && a(), () => {
    t();
  }), [e, r, l, t, a]), {
    startTimeout: a,
    stopTimeout: t
  };
}
function R(n) {
  return c.useReducer((e) => !e, n);
}
export {
  h as useClickOutside,
  i as useEvent,
  w as useInterval,
  v as useIsomorphicLayoutEffect,
  I as useResizeObserver,
  C as useTimeout,
  R as useToggle
};
